import React, { useEffect, useState } from 'react';
import creativesApi from '../../apis/creatives-api';
import GlobalStore from '../../stores/global-store';
import CardCreative from '../../components/Cards/CardCreative';
import ModalCreative from '../../components/Modals/ModalCreative';
import './Creative.css';

function Creative() {
  const {setLoading} = GlobalStore.useContainer();
  const [creatives, setCreatives] = useState([]);
  const [creativeDetail, setCreativeDetail] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    async function getCreatives() {
      setLoading(true);
      const responseCreatives = await creativesApi.getCreatives();
      setCreatives(responseCreatives.data?.creatives || []);
      setLoading(false);
    }

    getCreatives();
  }, [setLoading]);

  const viewHandler = (creative_id) => {
    const creative = creatives.filter(item => item.creative_id === creative_id);
    setCreativeDetail(creative[0]);
    setModalOpen(true);
  };

  const copyHandler = (e, code) => {
    navigator.clipboard.writeText(code);
    setTimeout(() => {
      e.target.innerText = 'Copied';
    }, 100);
  };

  return (
    <div className="page-creatives container-fluid">
      <h1>Hình ảnh chiến dịch</h1>
      <div className="row">
        {creatives.length > 0 && (
          creatives.map(item => (
            <div className="col-md-3" key={item.creative_id}>
              <CardCreative
                creative={item}
                onCopy={(e) => copyHandler(e)}
                onView={() => viewHandler(item.creative_id)}
              />
            </div>
          ))
        )}
      </div>

      {modalOpen && (
        <ModalCreative
          creative={creativeDetail}
          onCloseModal={() => setModalOpen(false)}
        />
      )}
    </div>
  )
}

export default Creative;
